export enum STATUS_TRANFER {
    WAITING = 'WAITING', // รอ
    WAITING_APPOINTMENT = 'WAITING_APPOINTMENT', // รอ
    WAITING_APPROVE = 'WAITING_APPROVE', // รออนุมัติ
    APPROVE = 'APPROVE', //อนุมัติ
    NOT_APPROVE = 'NOT_APPROVE', //ไม่อนุมัติ
    DELETED = 'DELETED',
    REVIEW = 'REVIEW' // ทบทวน
}

export enum STATUS_LEASEAGREEMENT {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  CANCEL = 'CANCEL',
  TRANSFER = 'TRANSFER',
  DELETED = 'DELETED',
}

export const status_transfer_data: { value: string, label: string }[] = [
    {
        label: "อนุมัติ",
        value: STATUS_TRANFER.APPROVE
    },
    {
        label: "ไม่อนุมัติ",
        value: STATUS_TRANFER.NOT_APPROVE
    },
    {
        label: "ทบทวน",
        value: STATUS_TRANFER.REVIEW
    },
    {
        label: "รออนุมัติ",
        value: STATUS_TRANFER.WAITING_APPROVE
    },
    {
        label: "รอการชำระเงิน",
        value: STATUS_TRANFER.WAITING
    },
    {
        label: "รอการนัดทำสัญญา",
        value: STATUS_TRANFER.WAITING_APPOINTMENT
    },
]